/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {
    import fld = VoucherTaxDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class VoucherTaxDetailsEditor extends Common.GridEditorBase<VoucherTaxDetailsRow> {
        protected getColumnsKey() { return "OMS.VoucherTaxDetails"; }
        protected getDialogType() { return VoucherTaxDetailsDialog; }
        protected getLocalTextPrefix() { return VoucherTaxDetailsRow.localTextPrefix; }
        protected useViewMode() { return true; }
        
        protected form: VoucherTaxDetailsForm;
        amount = 0; markup = 0;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            
        }
        private autoSize;
        public getColumns() {

            var columns = super.getColumns();


            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });



            return columns;
        }

        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);

        //    if (e.isDefaultPrevented())
        //        return;

        //    var item = this.itemAt(row);
        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon
        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();

        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();

        //        if (target.hasClass('delete-row')) {
        //            Q.confirm('Delete record?', () => {
        //                var id = this.id(item);
        //                this.view.deleteItem(id);
        //                this.view.refresh();




        //            });
        //        }
        //        if (target.hasClass('edit numeric')) {
        //            super.onClick(e, row, cell);
        //        }
        //    }
        //}


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.IsInterState == true) {
                    item.IsInterState = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.IsInterState = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();

                }
            }

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.TaxSelectGrid;
            grid.applicableon = "Bill";
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            buttons.pop();

            buttons.push({
                title: "Select Tax",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.TaxId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems;//.filter(t => { return !Q.any(this.view.getItems(), n => n.TaxId == t.TaxId) });
                       var items = [];
                        selectedItems2.forEach(function (value: TaxRow) {
                            //alert(value.ProcessId);
                            var Tax = OMS.TaxRow.getLookup().itemById[value.TaxId];

                            var item: VoucherTaxDetailsRow = {
                                TaxName: Tax.TaxName,
                                TaxId: Tax.TaxId,
                                TaxRate: Tax.Rate,
                                IsInterState: false
                            }
                            items.push(item);
                        });

                        // alert('Length details' + rates.length);
                        for (let item of items) {
                            item[this.getIdProperty()] = "`" + this.nextId++;
                            //   alert('ID ' + rateitem.CostId);
                            if (this.validateEntity(item, item.DetailsId)) {
                                this.view.addItem(item);
                            }
                            this.view.refresh();

                        }
                    }

                    pickerDialog.dialogOpen();

                }
            });

            return buttons;
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.TaxId === row.TaxId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Tax already exists!');
                return false;
            }
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }


    }
}